export default "__VITE_ASSET__bfa88625__"